import * as _ from "lodash";
import * as React from "react";
import * as S from "@styled";

import { TestElementId } from "../actions/SidePanelActions";
import { getParameterType } from "../model/DefaultParametersInitializer";
import { IParameters, IParameterSchema, ParameterType } from "../model/IProcessData";
import { ParameterEditorValue } from "../model/ParameterEditorValue";
import { default as ComplexParameter } from "./ComplexParameter";
import { default as ParameterInput, ParameterInputModeSelector } from "./ParameterInput";
import LabelWithTooltip from "shared/components/LabelWithTooltip";
import { SortableComponent } from "./SortableArray";
import { TestProcessParameterEditorContainerId, ParameterEditorContainerId } from './SidePanel';

export class ParameterList extends React.Component<IParameterListProps, IParameterListState> {
    constructor(props: IParameterListProps) {
        super(props);
        this.state = {};
    }

    public render() {
        const parsedType = getParameterType(this.props?.argumentJson?.parameterType);
        const parameterList = this.getParameterList(parsedType);
        return <S.InnerParameterFieldset disabled={this.props.disabled}>{parameterList}</S.InnerParameterFieldset>
    }

    private getParameterList(parsedType: ParameterType) {
        const key = !this.props.isParentArrayParemeter ? this.parentNameOrEmpty(this.props.parentName) + this.props.argumentJson?.name : this.props.parentName;
        switch (parsedType) {
            case ParameterType.ComplexParameter:
                return (
                    <>
                        {this.props.isParentArrayParemeter || this.props.dontShowHeaderLabel ? null :
                            <legend className="bpmn-task-parameter-legend">
                                <ParameterHeaderLabel
                                    label={this.props.argumentJson?.name}
                                    description={this.props.argumentJson?.description}
                                    type={this.props.argumentJson?.type}
                                    defaultValue={this.props.argumentJson?.defaultValue}
                                />
                            </legend>}
                        <ComplexParameter {...this.props} passedKey={key} />
                    </>);

            case ParameterType.EnumParameter:
            case ParameterType.BooleanParameter:
            case ParameterType.TextParameter:
                const value: ParameterEditorValue = _.get(this.props.existingParameters, key as string);
                return <ParameterInput
                    key={key}
                    name={key}
                    label={this.props.argumentJson?.name}
                    requiredPattern={this.props.argumentJson?.regex}
                    value={value}
                    isValid={true}
                    elementId={this.props.elementId}
                    parameterSchema={this.props.argumentJson}
                    isForCompletion={this.props.isForCompletion}
                />;

            case ParameterType.ArrayParameter:
                {
                    const existingArrayOrExpression: any = _.get(this.props.existingParameters, key as string, []);
                    const isArray = Array.isArray(existingArrayOrExpression);
                    if (isArray) {
                        return (
                            <S.FormGroup
                                id={key}
                                onMouseEnter={this.handleMouseEnter}
                                onMouseLeave={this.handleMouseLeave}
                            >
                                {!this.props.dontShowHeaderLabel && (
                                    <S.FormGroup $inline={true}>
                                        <ParameterHeaderLabel
                                            shouldNotDisplayIcon={!this.state.isHovering}
                                            label={this.props.argumentJson?.name}
                                            description={this.props.argumentJson?.description}
                                            type={this.props.argumentJson?.type}
                                            defaultValue={this.props.argumentJson?.defaultValue}
                                        />
                                        {!this.props.isForCompletion && this.state.isHovering && (
                                            <ParameterInputModeSelector
                                                inputPropertyName={key}
                                                handleEditorModeChange={() => this.props.onChangeArrayToExpression(key)}
                                                currentModeName="array"
                                                originalModeName="array"
                                                disabled={this.props.disabled}
                                            />
                                        )}
                                    </S.FormGroup>
                                )}

                                <SortableComponent
                                    items={existingArrayOrExpression}
                                    parameterKey={key}
                                    disabled={this.props.disabled}
                                    parameterContainerId={this.props.elementId === TestElementId ? TestProcessParameterEditorContainerId : ParameterEditorContainerId}
                                    {...this.props}
                                />

                                {!this.props.isForCompletion && <S.Button
                                    key={key}
                                    id={key}
                                    onClick={() => this.props.onArrayItemAdd(key, this.props.argumentJson?.parameterTemplate)}
                                    disabled={this.props.disabled}
                                >
                                    {FRENDS.Localizations.AddItem}
                                </S.Button>}
                            </S.FormGroup>
                        );
                    } else {
                        return <ParameterInput
                            key={key}
                            name={key}
                            label={this.props.argumentJson?.name}
                            requiredPattern={this.props.argumentJson?.regex}
                            value={existingArrayOrExpression}
                            isValid={true}
                            elementId={this.props.elementId}
                            parameterSchema={this.props.argumentJson}
                        />;
                    }

                }

            case ParameterType.CancellationToken:
                {
                    return null;
                }
            default:
                console.log("Unknow parameterType:" + this.props.argumentJson?.parameterType);
                return null;
        }
    }
    private parentNameOrEmpty(entity: string | undefined) {
        return entity ? entity + "." : "";
    }

    private handleMouseEnter = () => {
        this.setState({ isHovering: true });
    }

    private handleMouseLeave = () => {
        this.setState({ isHovering: false });
    }
}

export interface IParameterListProps {
    argumentJson: IParameterSchema | undefined | null;
    existingParameters: IParameters;
    elementId: string | undefined;
    onArrayItemAdd: (id: string | undefined, parameters: any) => void;
    onChangeArrayToExpression: (key: string | undefined) => void;
    onArrayItemRemove: (key: string | undefined, index: number) => void;
    onArrayItemIndexChange: (key: string | undefined, oldIndex: number, newIndex: number) => void;
    parentName: string | undefined;
    dontShowHeaderLabel?: boolean;
    isParentArrayParemeter?: boolean;
    disabled?: boolean;
    isForCompletion?: boolean;
}
interface IParameterListState {
    isHovering?: boolean;
}

export const ParameterHeaderLabel: React.FC<ParameterHeaderLabelProps> = (props) => (
    <span>
        <LabelWithTooltip
            label={props.label}
            defaultValue={props.defaultValue}
            description={props.description}
            type={props.type}
            shouldNotDisplayIcon={props.shouldNotDisplayIcon !== undefined ? props.shouldNotDisplayIcon : true}
            containerClass="pointer label-with-tooltip-selector"
            useHover
        />
    </span>
)

interface ParameterHeaderLabelProps {
    label: string | undefined;
    description: string | undefined;
    type: string | undefined;
    defaultValue: string;
    shouldNotDisplayIcon?: boolean;
}
